import { useLocation, useNavigate } from "react-router-dom";
import { useLocalization } from "../../contexts/LocalizationContext";
import StrategyFullReportModal from "../../components/home/StrategyFullReportModal";
import pageStyles from "../../styles/PageLayout.module.css";
import styles from "./StrategyReportPage.module.css";
import homeStyles from "../HomePage/HomePage.module.css";

const StrategyReportPage = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { t, locale } = useLocalization();
  const isArabic = locale === "ar";

  const title = state?.title || t("StrategyReportSection.modalTitle", { title: "" });
  const subtitle = state?.subtitle || "";
  const clusterFlag = state?.clusterFlag || "";
  const content = state?.content ?? null;
  const initialSectionIndex = state?.initialSectionIndex ?? 0;
  const strategyTabLabel = t("ZeqiMainTab.assessment") || "Assessment";
  const reportsTabLabel = t("ZeqiMainTab.reports") || "Reports";

  const hasContent = Array.isArray(content)
    ? content.length > 0
    : Boolean(String(content || "").trim());

  if (!hasContent) {
    return (
      <section className={`${pageStyles.page} ${styles.fullBleed}`} data-page="strategy-report">
        {/* <div className={homeStyles.tabs} role="tablist">
          {[strategyTabLabel, reportsTabLabel].map((tab) => (
            <button
              key={tab}
              type="button"
              className={`${homeStyles.tab} ${tab === strategyTabLabel ? homeStyles.tabActive : ""}`}
              onClick={() => navigate(tab === strategyTabLabel ? "/" : "/reports")}
              role="tab"
              aria-selected={tab === strategyTabLabel}
            >
              {tab}
            </button>
          ))}
        </div>
        <div className={pageStyles.emptyState}>
          <h2 className={isArabic ? styles.rtl : ""}>
            {t("StrategyReportSection.noExtra") || "No additional report content yet."}
          </h2>
        </div> */}
      </section>
    );
  }

  return (
    <section className={`${pageStyles.page} ${styles.fullBleed}`} data-page="strategy-report">
      {/* <div className={homeStyles.tabs} role="tablist">
        {[strategyTabLabel, reportsTabLabel].map((tab) => (
          <button
            key={tab}
            type="button"
            className={`${homeStyles.tab} ${tab === strategyTabLabel ? homeStyles.tabActive : ""}`}
            onClick={() => navigate(tab === strategyTabLabel ? "/" : "/reports")}
            role="tab"
            aria-selected={tab === strategyTabLabel}
          >
            {tab}
          </button>
        ))}
      </div> */}
      <StrategyFullReportModal
        isOpen
        title={title}
        subtitle={subtitle}
        clusterFlag={clusterFlag}
        content={content}
        onClose={() => navigate(-1)}
        variant="page"
        initialSectionIndex={initialSectionIndex}
      />
    </section>
  );
};

export default StrategyReportPage;
